'use strict';

import { Dispatcher } from 'flux'
import assign from 'object-assign'

let AppDispatcher = assign(new Dispatcher(), {
    handleViewAction(action){
        this.dispatch({
            source: 'VIEW_ACTION',
            action: action
        });
    }
});

module.exports = AppDispatcher;


// WEBPACK FOOTER //
// ./dispatcher/AppDispatcher.js